import Sentry, { featureTags } from '@/services/sentry'
import Vue from 'vue'
import slideTypeHostingRateApi from '@/api/slideTypeHostingRate'

const SET_HOSTING_RATES = 'SET_HOSTING_RATES'
const SET_FETCH_PROMISE = 'SET_FETCH_PROMISE'

const _state = {
  hostingRates: null,
  fetchPromise: null,
}

const _getters = {
  hostingRates: (state) => state.hostingRates,
}

const mutations = {
  [SET_HOSTING_RATES](state, hostingRates) {
    Vue.set(state, 'hostingRates', hostingRates)
  },
  [SET_FETCH_PROMISE](state, promise) {
    Vue.set(state, 'fetchPromise', promise)
  },
}

const actions = {
  fetchSlideTypesHostingRate({ commit, state }) {
    if (state.fetchPromise) return state.fetchPromise

    const promise = slideTypeHostingRateApi.getSlideTypesHostingRate()
      .then((body) => {
        const hostingRates = (body && body.data) || {}
        commit(SET_HOSTING_RATES, hostingRates)
        return hostingRates
      })
      .catch((error) => {
        Sentry.captureException(error, {
          tags: featureTags({ featureFlag: 'SLPL-1078-slide-type-picker-sort', featureName: 'slide-type-picker-sort', taskId: 'SLPL-1078' }),
        })
      })
    commit(SET_FETCH_PROMISE, promise)
    return promise
  },
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
}
